function callback(cb) {
	const type = typeof cb;

	if (type === 'string' && window.ga.loaded) {
		document.location = cb;
	} else if (type === 'function') {
		cb();
	}
}

function sendEvent(cb, eventCategory, eventAction, eventLabel, nonInteraction = false) {
	window.setTimeout(() => callback(cb), 1000); // fallback if analytics.js fails to load

	window.ga('send', {
		hitCallback: () => callback(cb),
		hitType: 'event',
		transport: 'beacon',
		eventCategory,
		eventAction,
		eventLabel
	},
	{nonInteraction});
}

export default sendEvent;



// WEBPACK FOOTER //
// ./src/components/analytics/send.jsx